import { render, staticRenderFns } from "./PreCase.vue?vue&type=template&id=2a7f0e4a&scoped=true&"
import script from "./PreCase.vue?vue&type=script&lang=js&"
export * from "./PreCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f0e4a",
  null
  
)

export default component.exports